import { GamesService } from './../Services/games.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adduser',
  templateUrl: './adduser.component.html',
  styleUrls: ['./adduser.component.css']
})
export class AdduserComponent implements OnInit {
  user_name:string;
  user_email:string;
  user_password:string;
  user_name1:string;
  user_phone:string;
  user_website:string;
  icon:string='fa fa-user-plus';


  constructor( private games: GamesService) { }

  ngOnInit() {
  }

  addUser(){
    this.icon='fa fa-spinner fa-spin';

    //create form data
    let data = new FormData();
    data.append('name',this.user_name);
    data.append('email',this.user_email);
    data.append('password',this.user_password);
    data.append('username',this.user_name1);
    data.append('website',this.user_website);
    data.append('phone',this.user_phone); 
    //send the data to the service 

    this.games.addUser(data).subscribe(next=>{
      console.log(next)
      this.icon='glyphicon glyphicon-ok';

    },error=>{console.log(error)});


  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/adduser/adduser.component.ts